import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
// Lista de nombres en español de diferentes regiones
const SPANISH_NAMES = ['Lucía R.', 'Emilio T.', 'Carlos L.', 'Sofía M.', 'Valentina P.', 'Julián A.', 'María G.', 'Diego F.', 'Isabella C.', 'Mateo V.', 'Camila S.', 'Santiago D.', 'Ana B.', 'Miguel H.', 'Laura N.', 'Andrés M.', 'Paula R.', 'Fernando J.', 'Carmen O.', 'Roberto P.', 'Elena Q.', 'Francisco W.', 'Gabriela Z.', 'Luis K.', 'Victoria Y.', 'Jorge U.', 'Daniela I.', 'Ricardo E.', 'Natalia A.', 'Alberto X.'];
// Función para generar precio aleatorio entre $8.97 y $26.97
const generateRandomPrice = (): string => {
  const min = 897;
  const max = 2697;
  const cents = Math.floor(Math.random() * (max - min + 1) + min);
  return (cents / 100).toFixed(2);
};
// Función para obtener un nombre aleatorio diferente al anterior
const getRandomName = (previousName: string): string => {
  let newName = SPANISH_NAMES[Math.floor(Math.random() * SPANISH_NAMES.length)];
  // Asegurar que no se repita el mismo nombre
  while (newName === previousName && SPANISH_NAMES.length > 1) {
    newName = SPANISH_NAMES[Math.floor(Math.random() * SPANISH_NAMES.length)];
  }
  return newName;
};
// Función para generar tiempo aleatorio en un rango
const getRandomDelay = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1) + min) * 1000;
};
export function RecentPurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentPrice, setCurrentPrice] = useState('');
  const [previousName, setPreviousName] = useState('');
  const showPopup = useCallback(() => {
    // Generar nuevo nombre y precio
    const newName = getRandomName(previousName);
    const newPrice = generateRandomPrice();
    setCurrentName(newName);
    setCurrentPrice(newPrice);
    setPreviousName(newName);
    setIsVisible(true);
    // Ocultar después de 6-9 segundos
    const hideDelay = getRandomDelay(6, 9);
    setTimeout(() => {
      setIsVisible(false);
      // Programar el siguiente popup después de 28-55 segundos
      const nextDelay = getRandomDelay(28, 55);
      setTimeout(showPopup, nextDelay);
    }, hideDelay);
  }, [previousName]);
  useEffect(() => {
    // Esperar 18-35 segundos antes de mostrar el primer popup
    const initialDelay = getRandomDelay(18, 35);
    const timer = setTimeout(showPopup, initialDelay);
    return () => clearTimeout(timer);
  }, [showPopup]);
  const handleClose = () => {
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-61">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 w-full max-w-[260px] sm:max-w-[250px]" data-id="element-62">
          <div className="bg-gradient-to-br from-[#2D6A4F] to-[#1B4332] rounded-xl shadow-2xl overflow-hidden border border-[#52B788]/20" data-id="element-63">
            {/* Close button */}
            <button onClick={handleClose} className="absolute top-1.5 right-1.5 w-5 h-5 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors z-10" aria-label="Cerrar" data-id="element-64">
              <X className="w-3 h-3 text-white" data-id="element-65" />
            </button>

            <div className="flex items-center gap-3 p-3.5 pr-9" data-id="element-66">
              {/* Product image */}
              <div className="flex-shrink-0" data-id="element-67">
                <img src="https://cdn.magicpatterns.com/uploads/9WrQcZWLeYMEo1qTCJ92wY/Producto_Principal.png" alt="Quincena en Verde" className="w-12 h-16 object-cover rounded-md shadow-md" data-id="element-68" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-69">
                {/* Online indicator + label - Smallest text */}
                <div className="flex items-center gap-1.5 mb-1.5" data-id="element-70">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#52B788] animate-pulse" data-id="element-71" />
                  <span className="text-[11px] font-semibold text-white/80 uppercase tracking-wider" data-id="element-72">
                    COMPRA RECIENTE
                  </span>
                </div>

                {/* Name - Largest and boldest text */}
                <h3 className="text-[17px] font-bold text-[#F4A261] mb-1 truncate leading-tight" data-id="element-73">
                  {currentName}
                </h3>

                {/* Edition + Price - Medium text, slightly larger than before */}
                <p className="text-[13px] text-white/90 leading-tight" data-id="element-74">
                  Edición digital •{' '}
                  <span className="font-semibold" data-id="element-75">${currentPrice} USD</span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}